module.exports = __webpack_public_path__ + "media/images/mobile/abouts/start-bd552c43c03445e9f57d8c75820d0e71.png";